import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const projects = [
  {
    tag: "iOS · Productivity",
    title: "Quick Note",
    desc: "Friction-free note-taking for the lock screen generation.",
    accent: "from-red-600 to-red-900",
    year: "2025",
  },
  {
    tag: "iOS · Lifestyle",
    title: "Heart Point",
    desc: "Daily habit tracking for couples who want to stay close.",
    accent: "from-rose-600 to-red-800",
    year: "2025",
  },
  {
    tag: "iOS · Entertainment",
    title: "Pure Tuber",
    desc: "Distraction-free streaming, optimized for background play.",
    accent: "from-amber-600 to-red-800",
    year: "2024",
  },
  {
    tag: "iOS · Utility",
    title: "Car Play Companion",
    desc: "Smarter dashboards for your drive — maps, music, focus.",
    accent: "from-stone-700 to-stone-900",
    year: "2024",
  },
];

function Portfolio() {
  return (
    <section id="work" className="section relative bg-levi-surface border-y border-levi-border">
      <div className="container-xl">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-levi-primary" />
              <span className="eyebrow">Selected Work</span>
            </div>
            <h2 className="display-lg text-levi-text">
              Shipped. <br />
              <span className="text-levi-primary">Battle-tested.</span>
            </h2>
          </div>
          <a href="#contact" className="btn-ghost self-start md:self-end">
            Start yours
            <ArrowUpRight size={16} />
          </a>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 gap-6">
          {projects.map((p, i) => (
            <StaggerItem key={p.title}>
              <a
                href="#contact"
                className="group relative block aspect-[4/3] overflow-hidden border border-levi-border hover:border-levi-primary transition-all duration-500 cursor-pointer"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${p.accent} opacity-80 group-hover:opacity-100 transition-opacity duration-500`} />
                <div className="absolute inset-0 bg-noise opacity-30 mix-blend-overlay" />
                <div className="absolute inset-0 bg-gradient-to-t from-levi-bg/90 via-levi-bg/20 to-transparent" />

                <div className="relative h-full p-8 md:p-10 flex flex-col justify-between text-levi-text">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-ultra text-white/80">
                      {p.tag}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-ultra text-white/60">
                      {p.year} · 0{i + 1}
                    </span>
                  </div>

                  <div>
                    <h3 className="font-display text-4xl md:text-5xl tracking-wider uppercase mb-3 text-white">
                      {p.title}
                    </h3>
                    <p className="text-white/80 max-w-md mb-6">{p.desc}</p>
                    <span className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-white group-hover:text-levi-accent transition-colors">
                      Case study
                      <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </span>
                  </div>
                </div>
              </a>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default Portfolio;
